module.exports = global["ReactDOM"] = require("-!./index.js");